import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACS_SuicideSafetyPlanIntervention = ({
   itemsRef,
   showErrorFor,
}) => {

   return (
      <form id='ACS_SuicideSafetyPlanIntervention' className='file-pdf-document'>
         <div className='file-template'>
            <h3>SAFETY PLAN INTERVENTION</h3>
            <span className='eleHeader'>Step 1: Warning signs:</span>
            <table>
               <tr>
                  <td className='w-750'>1.
                     <input type="text" id="txtWarningSigns_1" name="txtWarningSigns_1" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-750'>2.
                     <input type="text" id="txtWarningSigns_2" name="txtWarningSigns_2" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-750'>3.
                     <input type="text" id="txtWarningSigns_3" name="txtWarningSigns_3" className='add-only' /> </td>
               </tr>
            </table>
            <span className='eleHeader'>Step 2: Internal coping strategies - Things I can do to take my mind off my problems without contacting another person:</span>
            <table>
               <tr>
                  <td className='w-750'>1.
                     <input type="text" id="txtICS_1" name="txtICS_1" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-750'>2.
                     <input type="text" id="txtICS_2" name="txtICS_2" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-750'>3.
                     <input type="text" id="txtICS_3" name="txtICS_3" className='add-only' /> </td>
               </tr>
            </table>
            <span className='eleHeader'>Step 3: People and social settings that provide distraction:</span>
            <table>
               <tr>
                  <td className='w-100'><span>1. Name:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtName_1" name="txtName_1" className='add-only' /> </td>
                  <td className='w-100'><span>Phone:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtPhone_1" name="txtPhone_1" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-100'><span>2. Name:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtName_2" name="txtName_2" className='add-only' /> </td>
                  <td className='w-100'><span>Phone:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtPhone_2" name="txtPhone_2" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-100'><span>3. Place:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtPlace_1" name="txtPlace_1" className='add-only' /> </td>
                  <td className='w-100'><span>4. Place: </span></td>
                  <td className='w-225'>
                     <input type="text" id="txtPlace_2" name="txtPlace_2" className='add-only' /> </td>
               </tr>
            </table>
            <span className='eleHeader'>Step 4: People whom I can ask for help: </span>
            <table>
               <tr>
                  <td className='w-100'><span>1. Name:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtName_3" name="txtName_3" className='add-only' /> </td>
                  <td className='w-100'><span>Phone:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtPhone_3" name="txtPhone_3" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-100'><span>2. Name:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtName_4" name="txtName_4" className='add-only' /> </td>
                  <td className='w-100'><span>Phone:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtPhone_4" name="txtPhone_4" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-100'><span>3. Name:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtName_5" name="txtName_5" className='add-only' /> </td>
                  <td className='w-100'><span>Phone:</span></td>
                  <td className='w-225'>
                     <input type="text" id="txtPhone_5" name="txtPhone_5" className='add-only' /> </td>
               </tr>
            </table>
            <span className='eleHeader'>Step 5:Professionals or agencies I can contact during a crisis: </span>

            <table>
               <tr>
                  <td className='w-250'><span>1. Clinician Name</span></td>
                  <td className='w-200'> <input type="text" id="txtClinicianName_1" name="txtClinicianName_1" className='add-only' /> </td>
                  <td className='w-100'><span>Phone</span></td>
                  <td className='w-200'> <input type="text" id="txtClinicianPhone_1" name="txtClinicianPhone_1" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span>Clinician Pager or Emergency Contact #</span>
                     <input type="text" id="txtEmergencyContact" name="txtEmergencyContact" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-250'><span>2. Clinician Name</span></td>
                  <td className='w-200'> <input type="text" id="txtClinicianName_2" name="txtClinicianName_2" className='add-only' /> </td>
                  <td className='w-100'><span>Phone:</span></td>
                  <td className='w-200'> <input type="text" id="txtClinicianPhone_2" name="txtClinicianPhone_2" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span>Clinician Pager or Emergency Contact #</span>
                     <input type="text" id="txtEmergencyContact1" name="txtEmergencyContact1" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-250'><span>3.Suicide Prevention Lifeline:</span></td>
                  <td className='w-500'>
                     <input type="text" id="txtUrgentCare" name="txtUrgentCare" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-250'><span>4.Local Emergency Service</span></td>
                  <td className='w-500'>
                     <input type="text" id="txtUrgentCareAddress" name="txtUrgentCareAddress" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-250'><span>Emergency Services Address</span></td>
                  <td className='w-500'>
                     <input type="text" id="txtUrgentCarePhone" name="txtUrgentCarePhone" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-250'><span>Emergency Services Phone</span></td>
                  <td className='w-500'>
                     <input type="text" id="txtCareCrisisHotline" name="txtCareCrisisHotline" className='add-only' /> </td>
               </tr>
            </table>

            <span className='eleHeader'>Making the environment safe:</span>
            <table>
               <tr>
                  <td className='w-750'>1. <input type="text" id="txtEnvironmentSafe_1" name="txtEnvironmentSafe_1" className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-750'>2. <input type="text" id="txtEnvironmentSafe_2" name="txtEnvironmentSafe_2" className='add-only' /> </td>
               </tr>
            </table>







         </div>
      </form>

   )
}    